declare let gon: {
  driver_android_url: string
  rider_android_url: string
  driver_ios_url: string
  rider_ios_url: string
}

import { AppWaze, AppRider, buildDeeplinkLink } from 'core/services/download'

export class UniversalLinks {
  private ui: {
    driverPlaystoreBtn: HTMLAnchorElement | null
    riderPlaystoreBtn: HTMLAnchorElement | null
    driverAppstoreBtn: HTMLAnchorElement | null
    riderAppstoreBtn: HTMLAnchorElement | null
    riderAndroidDeeplinkBtn: HTMLAnchorElement | null
    driverAndroidDeeplinkBtn: HTMLAnchorElement | null
    riderIosDeeplinkBtn: HTMLAnchorElement | null
    driverIosDeeplinkBtn: HTMLAnchorElement | null
  }

  constructor(el: any) {
    this.ui = {
      driverPlaystoreBtn: el.querySelector('#waze-playstore-btn'),
      riderPlaystoreBtn: el.querySelector('#carpool-playstore-btn'),
      driverAppstoreBtn: el.querySelector('#waze-appstore-btn'),
      riderAppstoreBtn: el.querySelector('#carpool-appstore-btn'),

      driverAndroidDeeplinkBtn: el.querySelector('#waze-android-deeplink-btn'),
      riderAndroidDeeplinkBtn: el.querySelector('#carpool-android-deeplink-btn'),
      driverIosDeeplinkBtn: el.querySelector('#waze-ios-deeplink-btn'),
      riderIosDeeplinkBtn: el.querySelector('#carpool-ios-deeplink-btn')
    }

    this.setDownloadButtonsLinks()
    this.setDeeplinks()
    this.allowOpenDeepLinksInFacebookBrowser()

    const searchParams = new URLSearchParams(document.location.search)
    if (searchParams.get('test_tracking') === 'true') {
      this.skipULPage()
    }
  }

  private setDownloadButtonsLinks(): void {
    this.setUrl(this.ui.driverPlaystoreBtn, gon.driver_android_url)
    this.setUrl(this.ui.driverAppstoreBtn, gon.driver_ios_url)
    this.setUrl(this.ui.riderPlaystoreBtn, gon.rider_android_url)
    this.setUrl(this.ui.riderAppstoreBtn, gon.rider_ios_url)
  }

  private setDeeplinks(): void {
    this.setUrl(this.ui.driverAndroidDeeplinkBtn, buildDeeplinkLink(AppWaze))
    this.setUrl(this.ui.driverIosDeeplinkBtn, buildDeeplinkLink(AppWaze))
    this.setUrl(this.ui.riderAndroidDeeplinkBtn, buildDeeplinkLink(AppRider))
    this.setUrl(this.ui.riderIosDeeplinkBtn, buildDeeplinkLink(AppRider))
  }

  private setUrl(el: HTMLAnchorElement | null, url: string): void {
    if (el) {
      el.href = url || '#'
    }
  }

  private skipULPage(): void {
    if (!(this.isAndroid() || this.isIOS())) return

    const deepLink = this.isDriver() ? buildDeeplinkLink(AppWaze) : buildDeeplinkLink(AppRider)
    const storeLink = this.getDownloadLink()

    document.location.href = deepLink
    setTimeout(function() {
      document.location.href = storeLink
    }, 300)
  }

  private getDownloadLink(): string {
    if (this.isIOS()) {
      return this.isDriver() ? gon.driver_ios_url : gon.rider_ios_url
    } else if (this.isAndroid()) {
      return this.isDriver() ? gon.driver_android_url : gon.rider_android_url
    }

    return ''
  }

  private isDriver(): boolean {
    return document.body.classList.contains('ul-waze')
  }

  private isIOS(): boolean {
    return document.body.classList.contains('device-ios')
  }

  private isAndroid(): boolean {
    return document.body.classList.contains('device-android')
  }

  private allowOpenDeepLinksInFacebookBrowser(): void {
    const buttons = [
      this.ui.driverAndroidDeeplinkBtn,
      this.ui.driverIosDeeplinkBtn,
      this.ui.riderAndroidDeeplinkBtn,
      this.ui.riderIosDeeplinkBtn
    ]

    buttons
      .filter(el => el)
      .forEach((el: HTMLAnchorElement | null) => {
        const element = el as HTMLAnchorElement
        element.addEventListener('click', (e: MouseEvent) => {
          e.preventDefault()
          window.location.href = (e.target as HTMLAnchorElement).href
        })
      })
  }
}
